import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import React, { useState } from 'react'

const menuItems = [
    {name: 'About Us', link: '/about-us'},
    {name: 'Membership plans', link: '#'},
    {name: '404 Page', link: '#'},
    {name: 'FAQs', link: '/faqs'},
    {name: 'Help Center', link: '#'},
    {name: 'Login', link: '/auth/login'},
    {name: 'Register', link: '/auth/register'},
    {name: 'UI Elements', link: '#'},
    {name: 'Contact', link: '/contact'}
];

const menuItemsWithSubDrop = [
    {
        name: 'Shop',
        items: [
            {name: 'Shop Cart', link: '#'},
            {name: 'Shop Checkout', link: '#'},
            {name: 'Shop List', link: '#'},
            {name: 'Shop Order', link: '#'},
            {name: 'Shop Single', link: '#'}
        ]
    }
]

function PagesDropDown({ mobile = false }) {
    const [expandedSections, setExpandedSections] = useState({});

    const toggleSection = (index) => {
        setExpandedSections(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    if (mobile) {
        return (
            <MenuList className="ml-2 md:ml-4 w-full z-[100] p-0 dark:bg-dark-1 border-none shadow-none">
                {menuItemsWithSubDrop.map((section, sectionIndex) => (
                    <div key={sectionIndex} className="border-b border-gray-200 dark:border-gray-700 last:border-b-0">
                        <button
                            onClick={() => toggleSection(sectionIndex)}
                            className="flex justify-between items-center w-full p-3 text-left hover:bg-blue-50 dark:hover:bg-dark-3 rounded-md"
                        >
                            <span className="text-sm text-dark-1 dark:text-white">{section.name}</span>
                            <ChevronDown className={`h-4 w-4 transition-transform ${expandedSections[sectionIndex] ? 'rotate-180' : ''}`} />
                        </button>
                        <div className={`overflow-hidden transition-all duration-300 ${expandedSections[sectionIndex] ? 'max-h-96' : 'max-h-0'}`}>
                            <div className="pl-4 space-y-1">
                                {section.items.map((item, itemIndex) => (
                                    <MenuItem
                                        key={itemIndex}
                                        className="p-2 hover:bg-blue-50 hover:text-blue-600 text-sm text-dark-1
                                        dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400 rounded-md"
                                    >
                                        <a href={item.link} className="w-full block">{item.name}</a>
                                    </MenuItem>
                                ))}
                            </div>
                        </div>
                    </div>
                ))}

                {/* Items simples */}
                {menuItems.map((item, index) => (
                    <MenuItem
                        key={index}
                        className="p-3 hover:bg-blue-50 hover:text-blue-600 text-sm text-dark-1
                        dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400 rounded-md
                        border-b border-gray-200 dark:border-gray-700 last:border-b-0"
                    >
                        <a href={item.link} className="w-full block">{item.name}</a>
                    </MenuItem>
                ))}
            </MenuList>
        );
    }

    return (
        <MenuList className="p-2 min-w-[220px] z-[100] dark:bg-dark-1 rounded-lg shadow-lg">
            {menuItemsWithSubDrop.map((section, sectionIndex) => (
                <Menu key={sectionIndex} placement="right-start" offset={10} allowHover>
                    <MenuHandler>
                        <MenuItem className="flex items-center w-full justify-between p-3 hover:bg-blue-50 hover:text-blue-600 rounded-md text-dark-1 dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400">
                            <span className="text-sm">{section.name}</span>
                            <ChevronRight className="h-4 w-4" />
                        </MenuItem>
                    </MenuHandler>
                    <MenuList className="p-2 min-w-[200px] z-[100] dark:bg-dark-1 rounded-lg shadow-lg">
                        {section.items.map((item, itemIndex) => (
                            <MenuItem 
                                key={itemIndex} 
                                className="p-3 hover:bg-blue-50 hover:text-blue-600 text-sm rounded-md text-dark-1 dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400"
                            >
                                <a href={item.link} className="w-full block">{item.name}</a>
                            </MenuItem>
                        ))}
                    </MenuList>
                </Menu>
            ))}

            {/* Items simples */}
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    className="p-3 hover:bg-blue-50 hover:text-blue-600 text-sm rounded-md text-dark-1
                    dark:text-white dark:hover:bg-dark-3 dark:hover:text-blue-400"
                >
                    <a href={item.link} className="w-full block">{item.name}</a>
                </MenuItem>
            ))}
        </MenuList>
    )
}

export default PagesDropDown